import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-data-grid-field',
    templateUrl: './data-grid-field.component.html',
    styleUrls: ['./data-grid-field.component.scss']
})
export class DataGridFieldComponent {
    @Input() public title: string;
}
